import Refurbished from 'elem/compPage/Refurbished';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/refurbished';
import SEOlinksA from '@/components/SEOlinksA';

export default function RefurbishedPage({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('refurbished');
    const router = useRouter();
    const { locale } = router;

    useEffect(() => {
        if (!['us'].includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <Refurbished />
        </PageLayout>
    );
}
